export type Loading = {loading: true}
export type LoadableReady<T> = {loading: false, loaded: T}
export type Loadable<T> = Loading | LoadableReady<T>

export function isReady<T>(loadable: Loadable<T>): loadable is LoadableReady<T> {
    return !loadable.loading;
}

export function createLoadable<T>(value: T | null): Loadable<T> {
    return value == null ?
        {loading: true} :
        {loading: false, loaded: value};
}